import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { provideIcons } from '@ng-icons/core';
import { heroBuildingOfficeSolid } from '@ng-icons/heroicons/solid';
import {
  ionAddOutline,
  ionArrowBackCircleOutline,
  ionBarChartOutline,
  ionCheckmarkOutline,
  ionChevronBackOutline,
  ionChevronForwardOutline,
  ionColorPaletteOutline,
  ionCopyOutline,
  ionCreateOutline,
  ionCubeOutline,
  ionEyeOffOutline,
  ionEyeOutline,
  ionGitNetworkOutline,
  ionHelpCircleOutline,
  ionLogOutOutline,
  ionMegaphoneOutline,
  ionNotificationsOutline,
  ionOpenOutline,
  ionPeopleOutline,
  ionPersonOutline,
  ionPricetagOutline,
  ionPulseOutline,
  ionSearchCircleOutline,
  ionSettingsOutline,
  ionSwapHorizontalOutline,
  ionTimerOutline,
  ionTrophyOutline,
} from '@ng-icons/ionicons';
import { provideNgxMask } from 'ngx-mask';
import { provideQuillConfig } from 'ngx-quill';
import { provideToastr } from 'ngx-toastr';
import { routes } from './app.routes';
import { httpBackendLogInterceptor } from './interceptors/http-backend-log.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(withFetch(), withInterceptors([httpBackendLogInterceptor])),
    provideNgxMask(),
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideIcons({
      ionChevronBackOutline, //arrow back
      ionChevronForwardOutline, //arrow forward
      ionEyeOutline, //password visibility
      ionEyeOffOutline, //password visibility off
      ionGitNetworkOutline, //menu subscriptions
      ionPersonOutline, //menu users
      ionCreateOutline, //menu create
      ionSettingsOutline, //menu settings
      ionSwapHorizontalOutline, //menu transactions
      ionPulseOutline, //menu activity
      ionHelpCircleOutline, //menu help
      ionLogOutOutline, //menu logout
      ionNotificationsOutline, //menu notifications
      ionColorPaletteOutline, //menu theme
      ionAddOutline, //menu add
      ionCubeOutline, //menu packages
      ionPricetagOutline, //menu coupons
      ionPeopleOutline, //menu users
      ionArrowBackCircleOutline, //arrow back circle
      ionBarChartOutline, //menu reports
      ionMegaphoneOutline, //menu campaigns
      ionTimerOutline, //menu timer
      ionCheckmarkOutline,
      ionOpenOutline,
      ionCopyOutline,
      ionTrophyOutline,
      ionSearchCircleOutline,
      heroBuildingOfficeSolid, //company/business icon for contact-team section
    }),
    provideAnimations(),
    provideToastr({
      positionClass: 'toast-bottom-center',
      preventDuplicates: true,
      closeButton: true,
      timeOut: 3000,
    }),
    provideQuillConfig({
      modules: {
        toolbar: [
          ['bold', 'italic', 'underline', 'strike'],
          [{ list: 'ordered' }, { list: 'bullet' }],
          ['link'],
          ['clean'],
        ],
      },
    }),
  ],
};
